import React from 'react'
import '../pages/LocalSSOLogin.css'

// Shown when GET /auth/session fails with anything other than a 401 -- a 5xx, a
// timeout, the network being down. Those mean the server could not answer, not
// that the sub-broker is signed out, and showing the sign-in page for them is
// what let #52869 look like a session bug for most of a day: the portal was
// returning 500 on a missing database column and quietly offered a login form,
// so no one saw a server error anywhere and the admin just kept signing in
// again.
//
// Deliberately offers a retry rather than a link to /login: signing in again
// cannot fix a server fault, and sending someone round that loop is exactly the
// dead end this screen exists to stop.
export default function SessionUnavailable() {
  return (
    <div className="login-panel">
      <div className="login-card">
        <span className="login-status"><i /> SERVICE UNAVAILABLE</span>
        <h2 style={{ fontSize: '2.2rem' }}>We can't reach the server</h2>
        <div className="login-error" role="alert">
          This is a problem at our end, not with your account &mdash; you have not been
          signed out. Please try again in a moment.
        </div>
        <button
          type="button"
          className="login-change-mobile"
          style={{ background: 'none', border: 0, cursor: 'pointer' }}
          onClick={() => window.location.reload()}
        >
          Try again
        </button>
      </div>
    </div>
  )
}
